var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeenyiconsTickSolid({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_806_264)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3104 5.13999L9.57925 19.8712L1.24805 11.54C1.39641 10.6889 1.68739 10.5068 2.37925 10.4088L9.57925 17.6088L23.1792 4.00879C24.0388 4.12965 24.3059 4.33709 24.3104 5.13999Z",
    fill: "#55A803"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_806_264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.779297 0.339996)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeenyiconsTickSolid);
export default __webpack_public_path__ + "static/media/teenyicons_tick-solid.992fbfe0f37c8b434a1a5e0727d7b48e.svg";
export { ForwardRef as ReactComponent };